import { Box, Grid, IconButton, Link, Tooltip } from "@mui/material";
import {
  EmailOption,
  QuickSendScheduleContext,
  ScheduleTimeDialogSource,
} from "contexts/QuickSendSchedule";
import { useContext } from "react";
import { PreviewMessage } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import { DAYS_TO_DELAY_FOLLOWUP } from "constants/templates";
import { TemplateContentType } from "features/Influencer/ContactList/schema";

import { getFollowUpEmailScheduledTime } from "../../PreviewIndividual/helpers";
import styles from "./styles";

interface Props {
  preview: PreviewMessage;
  index: number;
  emailMessages?: PreviewMessage[];
}

const ScheduledTime = ({ preview, index, emailMessages }: Props) => {
  const {
    shortenedSendAt,
    presetSendAt,
    handleRemoveScheduledAt,
    selectedOption,
    setScheduleDialogSource,
  } = useContext(QuickSendScheduleContext);

  const handleChangeTime = () => {
    setScheduleDialogSource(ScheduleTimeDialogSource.CHANGE);
  };

  if (
    (preview?.contentType === TemplateContentType.OUTREACH ||
      preview.contentType === TemplateContentType.INBOX) &&
    shortenedSendAt &&
    selectedOption === EmailOption.schedule
  ) {
    return (
      <Grid
        container
        sx={styles.scheduledAtContainer}
        onClick={(e: CustomEvent) => e.stopPropagation()}
      >
        <Tooltip title="Remove scheduled time">
          <IconButton
            onClick={handleRemoveScheduledAt}
            sx={{ fontSize: 12, pr: 1, ml: -1 }}
          >
            <Box component="i" className="fa-regular fa-circle-xmark" />
          </IconButton>
        </Tooltip>

        <Box component="em">
          Scheduled to send: {shortenedSendAt}
          <Link sx={styles.changeButton} onClick={handleChangeTime}>
            Change
          </Link>
        </Box>
      </Grid>
    );
  } else if (preview?.contentType === TemplateContentType.FOLLOWUP) {
    const cumulativeDelayDays = emailMessages
      ? emailMessages
          .slice(1, index + 1)
          .reduce(
            (sum, msg) => sum + (msg.delayDays ?? DAYS_TO_DELAY_FOLLOWUP),
            0,
          )
      : DAYS_TO_DELAY_FOLLOWUP * index;
    const startFrom =
      selectedOption === EmailOption.schedule ? presetSendAt : null;
    return (
      <Box sx={styles.scheduledAtContainer} component="em">
        Scheduled to send:{" "}
        {getFollowUpEmailScheduledTime(cumulativeDelayDays, startFrom)}
      </Box>
    );
  } else {
    return <></>;
  }
};

export default ScheduledTime;
